export class VehicleEquipment {
  code: string;
  description: string;
  status: VehicleEquipmentStatusEnum;

  vehicleEquipmentMapper(equipStatus: string): VehicleEquipmentStatusEnum {
    switch (equipStatus) {
      case 'S':
        return VehicleEquipmentStatusEnum.Series;
      case 'O':
        return VehicleEquipmentStatusEnum.Optional;
      case '?':
        return VehicleEquipmentStatusEnum.Unknown;
      default:
        return null;
    }
  }
}

export enum VehicleEquipmentStatusEnum {
  Series = "Series",
  Optional = "Optional",
  Unknown = "Unknown"
}
